module.exports = __webpack_public_path__ + "img/injectionsteps_step11.58a2523d.png";